<template>
  <div v-if="show"
    class="context-menu"
    :style="{ top: y + 'px', left: x + 'px' }"
    @click.stop
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    show: { type: Boolean, default: false },
    x:    { type: Number, default: 0 },
    y:    { type: Number, default: 0 },
  },
}
</script>

<style>
.context-menu {
  position: fixed;
  z-index: 9999;
  background: #2b2b2b;
  border: 1px solid #555;
  border-radius: 4px;
  padding: 4px 0;
  min-width: 160px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}
.context-menu-item {
  padding: 6px 16px;
  color: #ccc;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;
}
.context-menu-item:hover {
  background: #3d3d3d;
  color: #fff;
}
.context-menu-separator {
  border-top: 1px solid #444;
  margin: 4px 0;
}
</style>
